module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/small.e28c0634a4923efd4df3.jpg";